<template>
  <div>
    <v-snackbar
      :value="flash.method === 'snack' && flash.show"
      :color="flash.type"
      top
      center
      :timeout="flash.timeout"
      @input="reset"
    >
      {{ flash.message }}
      <template #action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="reset"
        >
          {{ $t('Close') }}
        </v-btn>
      </template>
    </v-snackbar>

    <portal to="flash">
      <v-fade-transition hide-on-leave>
        <!-- eslint-disable -->
        <v-alert
          v-if="flash.method === 'alert' && flash.show"
          :key="flash.key"
          :value="true"
          :type="flash.type || 'success'"
          dismissible
        >
          <div v-html="flash.message"></div>
        </v-alert>
        <!-- eslint-enable -->
      </v-fade-transition>
    </portal>
  </div>
</template>

<script>
import some from 'lodash/some';
import findKey from 'lodash/findKey';

export default {
  data() {
    return {
      flash: {
        show: false,
        timeout: 3000,
        method: '',
        type: '',
        message: '',
        key: null
      }
    }
  },

  watch: {
    '$page.props.flash': {
      handler() {
        if (this.hasFlashThroughInertiaPageProps()) {
          this.setFlashThroughInertiaPageProps();
        } else {
          this.reset();
        }
      },
      deep: true,
    },
  },

  created() {
    if (this.hasFlashThroughInertiaPageProps()) {
      this.setFlashThroughInertiaPageProps();
    }
  },

  methods: {
    reset() {
      this.flash.show = false;
    },

    snack(type, message, timeout = 8000) {
      this.flash.show = true;
      this.flash.method = 'snack';
      this.flash.timeout = timeout;
      this.flash.type = type;
      this.flash.message = message;
    },

    hasFlashThroughInertiaPageProps() {
      return some(this.$page.props.flash.types, message => message !== null);
    },

    setFlashThroughInertiaPageProps() {
      const type = this.getFlashTypeThroughInertiaPageProps();
      this.flash.show = true;
      this.flash.method = this.$page.props.flash.method;
      this.flash.type = type;
      this.flash.message = this.$page.props.flash.types[type];
      this.flash.key = Date.now();
    },

    getFlashTypeThroughInertiaPageProps() {
      return findKey(this.$page.props.flash.types, message => {
        return message !== null;
      });
    }
  }
}
</script>

<style scoped>
.fade-transition-enter-active,
.fade-transition-leave-active {
  transition-duration: .5s !important;
}
</style>